import React from "react";
import { useNavigate } from "react-router-dom";
import canvasImage from "../../assets/canvas-image.png";
import Shape from "../Shape/Shape";
import shape1 from "../../assets/shape1.svg";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";
import "./AboutSection.css";

const AboutSection = () => {
  const navigate = useNavigate();

  const handleQuoteClick = () => {
    navigate("/contact");
  };

  return (
    <section className="about-section">
      <div className="about-content">
        <div className="left-content">
          <h1>
            We make your
            <br />
            candy dreams
            <br /> come true!
          </h1>
          <p>
            At Hapy Candy Toys, we specialize in manufacturing high-quality
            candy toys for brands, events, and businesses. Whether you’re
            looking for bulk production or custom-designed treats, we bring your
            ideas to life with precision and creativity.
          </p>
          <button className="quote-button" onClick={handleQuoteClick}>
            Get a Quote
          </button>
          <ul className="points">
            <li className="point">
              <h2>Custom Candy Solutions</h2>
            </li>
            <p>
              We craft unique candy toys tailored to your specifications, from
              flavors to toy designs.
            </p>
            <li className="point">
              <h2>Bulk Production Expertise</h2>
              <p>
                Our state-of-the-art facilities ensure consistent quality, even
                for large-scale orders.
              </p>
            </li>
            <li className="point">
              <h2>Build Your Brand</h2>
              <p>
                Bring your idea and we will do the rest for you. From concept to
                end product, we will be your trusted partners.
              </p>
            </li>
            <li className="point">
              <h2>Fast Turnaround</h2>
              <p>
                We pride ourselves on delivering your orders on time, every
                time.
              </p>
            </li>
          </ul>
        </div>
        <div className="right-content">
          <img src={canvasImage} alt="Canvas Image" className="canvas-image" />
          <Shape svgPath={shape1} color="#FF6347" className="shape1" />
          <Shape svgPath={shape2} color="#F0CD95" className="shape2" />
          <Shape svgPath={shape3} color="#6FE22C" className="shape3" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
